import { LoaderFunctionArgs } from "react-router";
import { useLoaderData } from "react-router";
import { WORDPRESS_API_URL, WORDPRESS_API_PATH } from "~/lib/util";

export async function loader({ context, params }: LoaderFunctionArgs) {

	const res = await fetch(`${WORDPRESS_API_URL}${WORDPRESS_API_PATH}update?slug=${params.slug}&_embed=author`);
	const updates = await res.json();

	console.log(updates[0])

	return ({
		update: updates[0]
	})
}

export default function UpdatesIndexPage() {
	const { update } = useLoaderData<typeof loader>();

	return <>
		<section className="xl:container mx-4 xl:mx-auto">
			<p className="text-center text-base text-primary-500 dark:text-primary-100 hover:underline"><a href="/updates">Back to Updates</a></p>
	<h1 className="mt-4 text-center text-3xl md:text-6xl font-light">{ update.title.rendered }</h1>
	<p className="mt-4 text-center text-base text-primary-500 dark:text-primary-100">{ update._embedded.author[0].name } - { update.date }</p>

	<article className="prose dark:prose-invert dark:text-white mx-auto mt-10">
		{ update.feature_image && (
			<figure className="post-feature-image">
				<img src={update.feature_image} alt={update.title.rendered} />
			</figure>
		)}

		<div dangerouslySetInnerHTML={{ __html: update.content.rendered }} />
	</article>
</section>
	</>
}